var Vendd = (function (Vendd) {
    'use strict';

    Vendd.SharedLists = (function (SharedLists) {

        SharedLists.Messages = (function (Messages) {

            Messages.ShareCart = function (title) {
                var data = { title: title };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SharedLists.Messages.ShareCart', data);
            };
            Messages.ShareCart.className = 'Vendd.SharedLists.Messages.ShareCart';

            Messages.ShareCartSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SharedLists.Messages.ShareCartSuccess', response);
            };
            Messages.ShareCartSuccess.className = 'Vendd.SharedLists.Messages.ShareCartSuccess';

            Messages.ShareCartFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SharedLists.Messages.ShareCartFailure', response);
            };
            Messages.ShareCartFailure.className = 'Vendd.SharedLists.Messages.ShareCartFailure';


            Messages.ShareWishList = function (listId, title) {
                var data = { listId: listId, title: title };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SharedLists.Messages.ShareWishList', data);
            };
            Messages.ShareWishList.className = 'Vendd.SharedLists.Messages.ShareWishList';

            Messages.ShareWishListSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SharedLists.Messages.ShareWishListSuccess', response);
            };
            Messages.ShareWishListSuccess.className = 'Vendd.SharedLists.Messages.ShareWishListSuccess';

            Messages.ShareWishListFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SharedLists.Messages.ShareWishListFailure', response);
            };
            Messages.ShareWishListFailure.className = 'Vendd.SharedLists.Messages.ShareWishListFailure';


            Messages.SendList = function (code, title, email) {
                var data = { code: code, title: title, email: email };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SharedLists.Messages.SendList', data);
            };
            Messages.SendList.className = 'Vendd.SharedLists.Messages.SendList';

            Messages.SendListSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SharedLists.Messages.SendListSuccess', response);
            };
            Messages.SendListSuccess.className = 'Vendd.SharedLists.Messages.SendListSuccess';

            Messages.SendListFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.SharedLists.Messages.SendListFailure', response);
            };
            Messages.SendListFailure.className = 'Vendd.SharedLists.Messages.SendListFailure';

            return Messages;

        })(SharedLists.Messages || {});

        return SharedLists;

    })(Vendd.SharedLists || {});

    return Vendd;

})(Vendd || {});
